import React, { useEffect } from 'react';
import { icons } from 'assets';
import { InputWithAdornment } from 'Components/shared/inputs';
import { Menu, MenuItem } from 'Components/shared/menu';
import Text from 'Components/shared/text';
import styles from '../wallet.module.css';
import useForm from 'hooks/useForm';
import Button from 'Components/shared/button';
import TableDisplay from 'Components/shared/table';
import { Status, TransactionType } from 'Components/shared/transactions';
import Modal from 'Components/shared/modal';
import { TransactionEnd } from '../reusables';
import Hidden from 'Components/shared/hidden';
import { useGetUsersTransactions } from 'services/transactionService';
import { handleWalletDeposit, handleWithdrawQuote, handleWithdrawSwap, useGetWalletBalance } from 'services/walletService';
import { useQueryClient } from 'react-query';
import { convertDate } from 'utils/stringServices';
import { flagsMap } from 'utils/constants/maps';

const Formatter = new Intl.NumberFormat('en-US');
const NumberFormatter = new Intl.NumberFormat('en-US');



const tableStructure = {
    0:{
        renderItem: (item) => {
            return <Text style={{fontWeight:"300"}} variant="sm">Date <br />
             {convertDate(item.timestamp)}</Text>
        },
        cellStyle:{
            minWidth:"90px"
        }
    },
    1:{
        renderItem: (item) => {
            return <Text style={{fontWeight:"300"}} color="secondary" variant="sm">Exchange <br /><img width="18px" src={ flagsMap[item?.fromCurrency] || icons.nigeria_small} alt="country flag"/>
            <span style={{paddingLeft:"8px", color:"var(--primary-text)"}}>{NumberFormatter.format(item.fromAmount) +" "+ item.fromCurrency?.toUpperCase?.() }</span></Text>
        },
        cellStyle:{
            minWidth:"142px",
            wordBreak:"keep-all"
        }
    },
    2:{
        renderItem: (item) => {
            return <TransactionType type="swap" />
        }
    },
    3:{
        renderItem: (item) => {
            return <Text style={{fontWeight:"300"}} color="secondary" variant="sm">To: <br /><img width="18px" src={flagsMap[item.toCurrency]} alt="country flag"/>
            <span style={{paddingLeft:"8px", color:"var(--primary-text)"}}>{NumberFormatter.format(item.toAmount || 0) +" "+ item.toCurrency?.toUpperCase?.() }</span>
            </Text>
        },
        cellStyle:{
            minWidth:"142px"
        }
    },
    4:{
        renderItem: (item) => {
            return <Text style={{fontWeight:"300"}} color="secondary" variant="sm">Price <br /> 
                1 {item.toCurrency?.toUpperCase?.()} = 
                {` ${item.rate} ${item.toCurrency?.toUpperCase?.()}`}
            </Text>
        },
        cellStyle:{
            minWidth:"142px"
        }
    },
    
}

const getNumber = (str) => {
    const currencies = "€$₦";
    let replace = `[${currencies}\,]+`;
    let re = new RegExp(replace,"g");
    return parseFloat(str.replace(re, ""));
}

const SwapHome = () => {
    const [selectedState, setSelectedState] = React.useState({
        "from_currency": { name: "NGN", icon: icons.nigeria_small, currency: "₦" , max:true},
        "to_currency": { name: "USD", icon: icons.usa_small, currency: "$" },
    });
    const [showConfirmModal, setShowConfirmModal] = React.useState(false);
    const [showSuccessModal, setShowSuccessModal] = React.useState(false);
    const [isRefreshing, setIsRefreshing] = React.useState(false);

    const queryClient = useQueryClient();
    const {data, isLoading} = useGetUsersTransactions("swap");
    const {data:userBalance} = useGetWalletBalance();
    const [options, setOptions] = React.useState({"from_currency":[
        {max:true,icon:icons.nigeria_small, name:"NGN", currency:"₦", fullName:"Nigeria Naira", balance:userBalance?.data?.ngn},
        {icon:icons.euro_small, name:"EUR", currency:"€", fullName:"Euro", balance:userBalance?.data?.eur},
        {icon:icons.usa_small, name:"USD", currency:"$", fullName:"US Dollar", balance:userBalance?.data?.usd}
    ], "to_currency":[
        {icon:icons.usa_small, name:"USD", currency:"$", fullName:"US Dollar", balance:userBalance?.data?.usd},
        {icon:icons.euro_small, name:"EUR", currency:"€", fullName:"Euro", balance:userBalance?.data?.eur}
    ]})

     const selectionHandler = (field,selected) => {
         setOptions(prev => {
            const allOptions = [
                {icon:icons.nigeria_small, name:"NGN", currency:"₦", fullName:"Nigeria Naira", balance:userBalance?.data?.ngn},
                {icon:icons.euro_small, name:"EUR", currency:"€", fullName:"Euro", balance:userBalance?.data?.eur},
                {icon:icons.usa_small, name:"USD", currency:"$", fullName:"US Dollar", balance:userBalance?.data?.usd},

            ]
            //  const currency = selected.currency;
            //  const prevFieldOptions = prev[field];
            //  const toRemove = prevFieldOptions.find(item => item.currency == currency);
             let otherField = ""
             if(field === "from_currency"){
                otherField = "to_currency"

               const res = {
                    [field]: allOptions.map(item => {
                       
                        if( item.currency === selected.currency ){
                           return {
                               ...item, max: true
                           }
                       }
                       else{
                           return {
                               ...item, max: false
                           }
                       }
                    }),
                    [otherField]: allOptions.map(item => ({...item, max:false}))
                }
                console.log("COMPUTATION", res);
                return res
                
             }
             else if(field === "to_currency"){
               otherField ="from_currency";
               return {
                [otherField]: allOptions.map(item => {
                   if( item.currency === selected.currency ){
                       return {
                           ...item, max: true
                       }
                   }
                   else{
                       return {
                           ...item, max: false
                       }
                   }
                }),
                [field]: allOptions.map(item => ({...item, max:false}))
            }
             }
             
             
                 
 
         } )
        setSelectedState({...selectedState, [field]: field === "from_currency" ? {...selected, max: true}: {...selected, max:false}});
        setValues(prev => ({...prev,[field]: selected.currency }));
    }
    const confirmHandler = (e) => {
        e.preventDefault();
        setShowConfirmModal(true);
    }
    const completeHandler = async(e) => {
        e.preventDefault();
        const {data,status} = await handleWithdrawSwap(
            selectedState.from_currency.name.toLowerCase(),
            values.from_currency, selectedState.to_currency.name.toLowerCase(),
            values.to_currency,
        )
        if(status == "Ok"){
            setShowSuccessModal(true);
        }
    }
    const successHandler = (e) =>{
        e.preventDefault();
        queryClient.invalidateQueries(["users-transactions", "swap"]);
        setShowSuccessModal(false);
        setShowConfirmModal(false);
    }
    const initialState ={
        from_currency: '₦',
        to_currency: '$',
    }
    const submitHandler = ( values, errors, setSubmitting, setErrors) => {
    }
    const { values, setValues, handleChange } = useForm({initialState, submitHandler});
    const currencyMap = {
        "₦": "ngn",
        '$' : "usd",
        "€": "eur"
    }
    useEffect(() => {
        if(userBalance?.data)
        setOptions({
            from_currency:[
                {max:true,icon:icons.nigeria_small, name:"NGN", currency:"₦", fullName:"Nigeria Naira", balance:userBalance?.data?.ngn},
        {icon:icons.usa_small, name:"USD", currency:"$", fullName:"US Dollar", balance:userBalance?.data?.usd},
        {icon:icons.euro_small, name:"EUR", currency:"€", fullName:"Euro", balance:userBalance?.data?.eur}
            ],
            to_currency:[
                {icon:icons.usa_small, name:"USD", currency:"$", fullName:"US Dollar", balance:userBalance?.data?.usd},
                {icon:icons.euro_small, name:"EUR", currency:"€", fullName:"Euro", balance:userBalance?.data?.eur}
            ]
        })
    }, [userBalance?.data])
    const valueChangeHandler = async (e) => {
       handleChange(e);
       
       const {value, name} = e.currentTarget;
       const currencies = options.from_currency.reduce((acc, cur) => acc + cur.currency,"");
       let replace = `[${currencies}\,]+`;
       let re = new RegExp(replace,"g");
       const amount = parseFloat(value.replace(re, "") || 0);
       let otherField = ""
       const body = {};
       if(name === "from_currency"){
        otherField = "to_currency"
        
       }
       else {
        otherField = "from_currency"
       }
       body.fromcurrency = selectedState.from_currency.name.toLowerCase();
       body.tocurrency = selectedState.to_currency.name.toLowerCase();
       body.fromamount = name === "from_currency" ? amount : values[otherField].replace(re, "");
       body.toamount = name === "from_currency" ? values.to_currency.replace(re, ""): amount;
       const {data, status, message} = await handleWithdrawQuote(body.fromcurrency,
        body.fromamount,body.tocurrency  );
        if(status === "Ok"){
            console.log(data)
            setValues(prev => {
                return {
                    ...prev,
                    [otherField]: name === "from_currency" ? selectedState[otherField].currency + Formatter.format((data.toAmount || "").replace(re, ''))  : 
                     selectedState[otherField].currency + Formatter.format((data.fromAmount || "").replace(re, '')),
                     rate: data.rate
                }
            })
        }
      

    }
  
    const onRefreshHandler = async () => {
        setIsRefreshing(true)
        const {data, status, message} = await handleWithdrawQuote(selectedState.from_currency.name.toLowerCase(),
            values.from_currency,selectedState.to_currency.name.toLowerCase(), values.to_currency  );
            console.log(data, "LIKE SHA")
        setIsRefreshing(false);
    }
    console.log(values, data, "DATA")
    return (
        <div>
            <div className={styles.Swap}>
                <form className={styles.content}>
                    <SelectComponent leftLabel="From" value={values.from_currency} name ="from_currency" 
                    onChange={valueChangeHandler} setValues={setValues}  rightLabel={`${values.from_currency[0]}${NumberFormatter.format(userBalance?.data?.[currencyMap[values.from_currency[0]]] || 0)}`} 
                    onSelect={selectionHandler} selected={selectedState.from_currency}
                    options={options.from_currency || [{}]}/>
                    <div className='w-full text-center'>
                        <img src={icons.downArrow} alt="swap icon"/>
                    </div>
                    <SelectComponent onSelect={selectionHandler}
                    selected={selectedState.to_currency} setValues={setValues}
                    leftLabel="To (estimated)" value={values.to_currency} name ="to_currency" 
                    onChange={valueChangeHandler} rightLabel={`${values.to_currency[0]}${NumberFormatter.format(userBalance?.data?.[currencyMap[values.to_currency[0]]] || 0)}`} 
                   options={options.to_currency || [{}]} />
                    { !!values.rate && <div className='w-full' style={{textAlign:"right", color:"#64748B", fontSize:"14px"}}>
                        1 {selectedState["to_currency"]?.name} =  {`${values.rate} ${selectedState["from_currency"]?.name}`} 
                        <span style={ {transition:"transform 1s 100ms", tranform: "rotate(360deg)" }}>
                        <img src={icons.refresh} width="18px" alt="refresh icon" style={{paddingLeft:"8px",cursor:"pointer"}} onClick={onRefreshHandler} />
                        </span>
                    </div>}
                    <Button fullWidth onClick={confirmHandler}>Exchange</Button>
                    {/* <div className='row-start w-full' style={{flexDirection:"column", margin:"2rem 0",gap:"14px"}}>
                        <p className={`row-start w-full space-between`}>
                            <Text variant="sm" className="row-start"style={{color:"#64748B"}}>Minimum Recieved <img src={icons.question} alt="question" style={{marginLeft:"10px"}} /></Text>
                            <span>200 USD</span>
                        </p>
                        <p className={`row-start w-full space-between`}>
                            <Text variant="sm" className="row-start"style={{color:"#64748B"}}>Price Impact <img src={icons.question} alt="question" style={{marginLeft:"10px"}} /></Text>
                            <span style={{color:"var(--pending-color)"}}>14.0%</span>
                        </p>
                        <p className={`row-start w-full space-between`}>
                            <Text variant="sm" className="row-start"style={{color:"#64748B"}}>Slippage Tolerance <img src={icons.question} alt="question" style={{marginLeft:"5px"}} /></Text>
                            <Percentages />
                        </p>
                        <p className={`row-start w-full space-between`}>
                            <Text variant="sm" className="row-start"style={{color:"#64748B"}}>Pasth <img src={icons.question} alt="question" style={{marginLeft:"10px"}} /></Text>
                            <Pasths />
                        </p> 
                    </div> */}
                </form>
               
            </div>
            <div className={styles.table}>
                <Text variant="md2" tag="h2" style={{ fontWeight:"700",marginBottom:"24px"}}>Transactions</Text>
                <TableDisplay data={data || []}  column={tableStructure} emptyComponent={"No Data present"}/>
            </div>
            <Modal heading="Confirm Exchange" padding={false} style={{width:"414px"}}
            onClose={()=>setShowConfirmModal(false)} open={showConfirmModal}>
                    <div className='row-start space-between w-full' style={{flexDirection:"column"}}>
                        <div className='modal-padding w-full row-start' style={{flexDirection:"column", gap:"10px", alignItems:"flex-start",paddingTop:0}} >
                                <div className="row-start w-full space-between">
                                    <div>
                                        <Text variant="sm" color="secondary">Exchange</Text>
                                        <Text variant="sm" color="secondary">
                                            <img width="12px" src={selectedState.from_currency.icon} alt="nigeria flag"/>
                                            {values.from_currency}
                                        </Text>
                                    </div>
                                    <Text>{selectedState.from_currency.name}</Text>
                                </div>
                                <div className='row-start' >
                                    <img src={icons.downArrow} width="36px" alt="down arrow"/>
                                </div>
                                <div className="row-start w-full space-between">
                                    <div>
                                        <Text variant="sm" color="secondary">To</Text>
                                        <Text variant="sm" color="secondary">
                                            <img width="12px" src={selectedState.to_currency.icon} alt="nigeria flag"/>
                                           {values.to_currency}
                                        </Text>
                                    </div>
                                    <Text>{selectedState.to_currency.name}</Text>
                                </div>
                                <Text variant="sm" color="secondary" style={{fontSize:"11px"}}>
                                output is estimated. you will receive at least {`${values.to_currency.replace(/[$₦€]?/g, "")} ${selectedState.to_currency.name}`} or then transaction will revert.
                                </Text>
                        </div>
                        <div className='modal-padding w-full row-start' style={{backgroundColor:"#F8FAFC", flexDirection:"column", gap:"14px"}}>
                        <p className={`row-start w-full space-between`}>
                            <span className="row-start"style={{color:"#64748B", fontSize:"1rem"}}>Price </span>
                            <span>1 {selectedState["to_currency"]?.name} = {`${values.rate } ${selectedState["from_currency"]?.name}`}
                                <img src={icons.refresh} width="18px" alt="refresh icon" style={{paddingLeft:"8px",cursor:"pointer"}} />
                            </span>
                        </p>
                        {/* <p className={`row-start w-full space-between`}>
                            <span className="row-start"style={{color:"#64748B", fontSize:"1rem"}}>Minimum Recieved 
                            <img src={icons.question} alt="question" style={{marginLeft:"10px"}} /></span>
                            <span>200 USD</span>
                        </p>
                        <p className={`row-start w-full space-between`}>
                            <span className="row-start"style={{color:"#64748B", fontSize:"1rem"}}>Price Impact 
                             <img src={icons.question} alt="question" style={{marginLeft:"10px"}} /></span>
                            <span style={{color:"var(--pending-color)"}}>14.0%</span>
                        </p> */}
                        <div className="w-full">
                            <Button fullWidth onClick={completeHandler}>Confirm</Button>
                        </div>
                        </div>
                    </div>
            </Modal>
            <TransactionEnd success openModal={showSuccessModal} onSuccess={successHandler} />
        </div>
    )
}

const Percentages = (props) => {
    const [index, setIndex] = React.useState(0);
    return (
        <div className='row-start' style={{gap:"10px"}}>
            <span  onClick={() => setIndex(0)}
             style={{padding: "5px 10px", borderRadius:"5px",fontSize:"11px", cursor:"pointer",
           
            color: index==0?"white":"#64748B" , backgroundColor:index === 0 ?"#0169FF":"#E2E8F0"}}>0.1%</span>
            <span onClick={() => setIndex(1)} 
            style={{padding: "5px 10px", borderRadius:"5px",fontSize:"11px", cursor:"pointer",
            color: index==1?"white":"#64748B" , backgroundColor:index === 1 ?"#0169FF":"#E2E8F0"}}>0.5%</span>
            <span onClick={() => setIndex(2)}
            style={{padding: "5px 5px", borderRadius:"5px",fontSize:"10px", cursor:"pointer",
            color: index==2?"white":"#64748B" , backgroundColor:index === 2 ?"#0169FF":"#E2E8F0"}}>Custom%</span>
        </div>
    )
}
const Pasths = (props) => {
    return(
        <div className='row-start' style={{gap:"10px"}}>
           <p className='row-start' style={{fontSize:"11px",cursor:"pointer"}}><span>NGNT</span> <img src={icons.arrowRight} alt="arrow" width="7px" height="8px" /> </p>
           <p className='row-start' style={{fontSize:"11px",cursor:"pointer"}}><span>XLM</span> <img src={icons.arrowRight} alt="arrow" width="7px" height="8px" /> </p>
           <p className='row-start' style={{fontSize:"11px",cursor:"pointer"}}><span>USDC</span> <img src={icons.arrowRight} alt="arrow" width="7px" height="8px" /> </p>
        </div>
    )
}
const SelectComponent = (props) => {
    const {leftLabel, rightLabel, options,onSelect, selected, setValues, ...rest} = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    // const [selected, setSelected] = React.useState(options[0]);
    
    const clickHandler = (e) => {
        setAnchorEl(e.currentTarget);
    }
    const maxSelectHandler = (e) => {
        e.stopPropagation();
        setValues(prev => ({...prev,[props.name] : rightLabel}))
        inputRef.current.click()
        inputRef.current.focus();
    }
   
    const onSelectOptionHandler = (option) => {
        // setSelected({...option, max: true});  
        onSelect?.(props.name, option); 
        setAnchorEl(null);
        
    }
    const inputRef = React.useRef(null);
    useEffect(() => {
        inputRef.current.focus();
    },[])
    const element = (
        <div className="row-start" style={{gap:"10px", cursor:"pointer"}} onClick={clickHandler} >
            {selected.max && 
            <p onClick={maxSelectHandler} style={{backgroundColor:"#F2F2FF",color:"#0000FF",fontSize:"11px",
             borderRadius:"5px",padding:"5px 10px"}}>Max</p>}
            <img src={selected.icon} height="24px" alt={selected.name}/>
            <p>{selected.name}</p>
            <img src={icons.dropdown} alt="dropdown" />
        </div>
    )
    return(
        <div className='w-full'>
            <div className="row-start space-between w-full" style={{marginBottom:"8px"}}>
                <Text variant="sm" style={{fontSize:"700"}}>{leftLabel}</Text>
                <Text variant="sm" style={{color:"#64748B"}}>Balance: {rightLabel}</Text>
            </div>
            <InputWithAdornment 
            fullWidth
            onInput={(e) => {
                const currencies = options.reduce((acc, cur) => acc + cur.currency,"");
                let matching = `^[${currencies}]?[0-9\,]*$`;
                console.log(matching);
                if(!e.target.value.match(new RegExp(matching,"g"))){
                   e.target.value = e.target.value.slice(0, -1);
                    return false;
                }
                let replace = `[${currencies}\,]+`;
                let re = new RegExp(replace,"g");
                e.target.value = selected.currency + Formatter.format(e.target.value.replace(re, ''));
            }}
            ref={inputRef} className={styles.white} right={element} {...rest} />
            <Menu open={Boolean(anchorEl)} anchorEl={anchorEl}
            onClose={()=> setAnchorEl(null)}>
                {options.map((option, index) => {
                    return(
                        <>
                        <Hidden mdDown>
                        <MenuItem className="row-start space-between" style={{gap:'20px', minWidth:"350px", paddingRight:"16px"}} key={index} 
                        onClick={() => onSelectOptionHandler(option)}>
                           <div className='row-start' style={{gap:"15px"}}>
                            <img src={option.icon} width="24px" alt={selected.name}/>
                            <div >
                                <Text variant="sm">{option.name}</Text>
                                <Text color="secondary" variant="xs">{option.fullName}</Text>
                            </div>
                           </div>
                           <Text variant="md" >{`${option.currency}${NumberFormatter.format(option.balance)}`}</Text>
                        </MenuItem>
                        </Hidden>
                        <Hidden mdUp>
                            <MenuItem className="row-start space-between" style={{gap:'20px', minWidth:"180px"}} key={index} 
                            onClick={() => onSelectOptionHandler(option)}>
                            <div className='row-start' style={{gap:"15px"}}>
                                <img src={option.icon} width="24px" alt={selected.name}/>
                                <div >
                                    <Text variant="sm">{option.name}</Text>
                                    <Text color="secondary" variant="xs">{option.fullName}</Text>
                                </div>
                            </div>
                            <Text variant="md" >{`${option.currency}${NumberFormatter.format(option.balance)}`}</Text>
                            </MenuItem>
                        </Hidden>
                        </>)
                })}
            </Menu>
        </div>
    )
}
export default SwapHome;